// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_fp-3";
export var flatBottomCorners = "_fp-5";
export var productImage = "_fp-0";
export var quantityContainer = "_fp-2";
export var quantityHeader = "_fp-6";
export var tooltip = "_fp-1";
export var wrapAndEllipsesOverflow = "_fp-4";